<ng-container *ngIf="evento?.metaPixel && evento.metaPixel.trim() !== ''">
  <noscript>
    <img height="1" width="1" style="display:none"
         src="https://www.facebook.com/tr?id={{evento.metaPixel}}&ev=PageView&noscript=1" />
  </noscript>
</ng-container>
<div class="spinner-overlay" *ngIf="cargando">
  <div class="spinner"></div>
</div>

<!--BANNER-->
<section class="Banner" content="width=device-width m-xs-5" *ngIf="evento?.imagenes != 'undefined'">
  <div class="row">
    <div class="col-12 p-0">
      <section id="banner" class="carousel slide" data-ride="carousel" data-interval="3000">

        <!--Imagenes-->
        <div class="carousel-inner outerLink">
          <div class="carousel-item active h-25" *ngFor="let img of listaImagenes; let i = index" [class.active]="i === 0">
            <img src="{{img}}" class="img-fluid align-items-center">
          </div>
        </div>

        <!--Controles-->
        <a *ngIf="listaImagenes[1]" href="#banner" class="carousel-control-prev" data-slide="prev"><span
            class="carousel-control-prev-icon"></span></a>
        <a *ngIf="listaImagenes[1]" href="#banner" class="carousel-control-next" data-slide="next"><span
            class="carousel-control-next-icon"></span></a>
      </section>
    </div>
  </div>
</section>


<section class="seccionTitulo-linea">
  <div class="txtNombre">
    <h2 class="titulo-evento3">{{evento?.nombre}}</h2>
    <hr class="linea-naranja4" />

    <h3 class="pulep">
      <ng-container *ngIf="evento?.pulep">
        <span *ngIf="!evento.pulep.startsWith('AT20')">PULEP:&nbsp;</span>
        {{evento?.pulep}}
      </ng-container>
    </h3>

  </div>
</section>

<section class="container-fluid  mt-1  eventoVideo">
  <div class="pl-1 pr-1 sinPadding">
    <div class="row largo sinVideo">
      <!-- <div class="infoGene col-12">
        <h2 class="ubicaciones mt-2"><strong></strong></h2>

      </div> -->

      <div class="col-12 col-sm-12 col-lg-6  vid cjaDer" *ngIf="evento?.video" >
        <iframe class="vdoEvent" [src]='safeSrc' *ngIf="safeSrc!=null" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          <div class="info-organizador">
            <div class="">
              <div class="info-org"><strong class="bold">Responsable: </strong> {{organizadorNombre}}</div>
            </div>
            <div class="">
              <div class="info-org">
                <!-- remover - que tienen algunos nits -->
                <strong class="bold">NIT: </strong>{{organizadorId}}
            </div>


            </div>
          </div>

      </div>

      <div class=" col-12 col-sm-12 col-lg-6  vid " *ngIf="!evento?.video">
        <div *ngIf="!evento?.video " class="   qrImagen ">
          <div class="contenedorImagen">
            <img class="qrImg large-screen" [src]="darURL(3) && darURL(3) !== '' ? darURL(3) : darURL(1)" alt="">
            <img class="qrImgPerfil small-screen" src="{{darURL(1)}}" alt="">
          </div>
        </div>

        <div class="info-organizador">
          <div class="">
            <div class="info-org"><strong class="bold">Responsable: </strong> {{organizadorNombre}}</div>
          </div>
          <div class="">
            <div class="info-org"><strong class="bold">NIT: </strong> {{organizadorId}}</div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-6">
        <div class="alineacionText">
        <div class="montserrat tituloInfo">Información General</div>

        <div class="col-12  flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 39.png" alt="">
          <div class="detalle1"><strong class="bold">Fecha: </strong>  {{ darFecha(evento,true) }}</div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 37.png"
            alt="">
          <div class="detalle1"><strong class="bold">Apertura de puertas: </strong> {{ evento?.horaApertura |  horas}}
          </div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 44.png" alt="">
          <div class="detalle1"><strong class="bold">Inicio de la presentación: </strong> {{ evento?.horaInicio | horas}}</div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 39.png" alt="">
          <div class="detalle1"><strong class="bold">Fecha finalización: </strong>  {{darFecha(evento, false) }}</div>
        </div>
        <div class="col-12  flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 37.png" alt="">
          <div class="detalle1"><strong class="bold">Hora finalización evento: </strong>{{ evento?.horaFin | horas }}</div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 42.png" alt="">
          <div class="detalle1"><strong class="bold">Artistas: </strong> {{ evento?.artistas ? evento?.artistas : "Por confirmar" }}</div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 43.png" alt="">
          <div class="detalle1"><strong class="bold">Ciudad: </strong> {{evento?.ciudad?.nombre}}</div>
        </div>
        <div class="col-12   flotar lineH">
          <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 38.png" alt="">
          <div class="detalle1"><strong class="bold">Lugar: </strong> {{ evento?.lugar ? evento?.lugar : "Por confirmar" }}</div>
        </div>

      </div>



      </div>
        <div style="text-align: center;" class=" divBoton" *ngIf="!evento.soldOut" >

          <button *ngIf="evento?.id != 1957" class="botonCompra   action_button  bg-boton1" routerLink="/eventos/evento/{{miId}}/compra">COMPRAR</button>

          <button *ngIf="evento?.id == 1957" class="botonCompra   action_button  bg-boton1" routerLink="/eventos/evento/{{miId}}/compra">DONACIÓN</button>
        </div>

      </div>



      <div class="col-12 contenederoBlanco2 ">
        <div *ngIf="mapaV && evento?.video" class="mapaEvento">

        </div>

        <div *ngIf="mapaUrl && mapaUrl !== 'no'" class="mapI">
          <iframe *ngIf='mapaUrl' [src]='mapaUrl' width="100%"
            style="border:0; height: 100%;" allowfullscreen="" loading="lazy"></iframe>
        </div>


        <div class="divDescript marGen">
          <p *ngIf="evento?.visibleAP"><strong>Recuerda que desde YA puedes comprar los productos del evento
              con descuento en: <a class="colorMorado"
                href="https://allproductscol.com/eventos/evento/{{evento?.id}}">https://allproductscol.com/eventos/evento/{{evento?.id}}</a>
            </strong></p>



          <div class="recomendacion lato " [innerHTML]="this.evento?.descripcion">

          </div>


          <div class="">
            <h2 class="titulo-evento4">Recomendaciones</h2>
            <hr class="linea-naranja5" />
            <div class="recomendacion lato">{{evento?.terminosYCondiciones}}</div>
            <div class="recomendacion lato">{{evento?.recomendaciones}}</div>
            <div class="recomendacion lato">ADVERTENCIA DE COMPRA: RECIBIRÁS UN CÓDIGO QR A TU CORREO, ¡ESE CÓDIGO QR ES
              TU
              ENTRADA! REVISA SPAM</div>
          </div>

          <div class="" *ngIf="!evento.soldOut">
            <h2 class="titulo-evento4">Localidades y Precios</h2>
            <hr class="linea-naranja5" />
          </div>
        </div>



      </div>

    </div>

</section>

<!-- <div class="contenedor-tituloTabla">
  <div id="prueba9" class="mt-3">

    <div *ngIf="evento?.fechaCambioEtapa" class="proximaEtapa">
      <h5>
        Fecha de cambio próxima etapa: {{evento?.fechaCambioEtapa | date:'dd/MM/yyyy'}}
      </h5>
    </div>
  </div>
</div> -->



<div class="container-fluid" *ngIf="fecha>fechaActual && localidades.length == 0">
  <div class="row">
    <div class="col-12 centrarTexto mt-5 mb-5" id="contador">
      <h4 class="mb-3"><strong>Tiempo para abrir ventas</strong></h4>
      <div class="contenedor  ">


        <p> {{meses}} <span>Meses</span></p>
        <p> {{semanas}} <span>Semanas</span></p>
        <p> {{dias}} <span>Días</span></p>
        <p> {{horas}} <span>Horas</span> </p>
        <p> {{minutos}} <span>Minutos</span></p>
        <p> {{segundos}} <span>Segundos</span> </p>

      </div>
    </div>
  </div>
</div>

<section  class="tablaEventoPerfil mt-2 marGen " *ngIf="localidades.length >= 0 && !evento.soldOut">

    <!-- Hardcode para acordeon DOOM ZONA CERO 
    Si ves el código del siguiente div cuando el evento haya pasado puedes eliminarlo
    ATTE: ISAAC  -->

   <div *ngIf="evento?.id ==1986" class="doom-accordion centrar ffc tablatck">
  <div class="accordion-container">
    
    <!-- COMBO TRES DÍAS -->
    <div class="accordion-item">
      <div class="accordion-header" (click)="toggleAccordion('combo3')" 
           [class.active]="accordionState.combo3">
        <h3>{{getNombreEtapa(3)}}</h3>
        <div class="precio-desde">
          <span>Desde:</span>
          <span class="precio-min">{{getPrecioMinimo(3) | currency:'COP'}}</span>
        </div>
        <span class="accordion-icon" [class.rotated]="accordionState.combo3">▼</span>
      </div>
      <div class="accordion-content" [class.show]="accordionState.combo3">
        <div routerLink="compra" class="localidad-item" *ngFor="let localidad of getLocalidadesPorEtapa(3); let i = index"
             [style.animation-delay]="(i * 50) + 'ms'">
          <div class="localidad-info">
            <span class="localidad-nombre">{{localidad.nombre}}</span>
            <span class="ticket-badge">{{localidad.cantidadPersonasPorTicket}} Ticket<span *ngIf="localidad.cantidadPersonasPorTicket>1">s</span></span>
          </div>
          <div class="precio-final">
            {{(localidad.precio + localidad.servicio_iva + localidad.servicio) | currency:'COP'}}
          </div>
        </div>
      </div>
    </div>

    <!-- COMBO DOS DÍAS -->
    <div class="accordion-item">
      <div class="accordion-header" (click)="toggleAccordion('combo2')" 
           [class.active]="accordionState.combo2">
        <h3>{{getNombreEtapa(2)}}</h3>
        <div class="precio-desde">
          <span>Desde:</span>
          <span class="precio-min">{{getPrecioMinimo(2) | currency:'COP'}}</span>
        </div>
        <span class="accordion-icon" [class.rotated]="accordionState.combo2">▼</span>
      </div>
      <div class="accordion-content" [class.show]="accordionState.combo2">
        <div routerLink="compra" class="localidad-item" *ngFor="let localidad of getLocalidadesPorEtapa(2); let i = index"
             [style.animation-delay]="(i * 50) + 'ms'">
          <div class="localidad-info">
            <span class="localidad-nombre">{{localidad.nombre}}</span>
            <span class="ticket-badge">{{localidad.cantidadPersonasPorTicket}} Ticket<span *ngIf="localidad.cantidadPersonasPorTicket>1">s</span></span>
          </div>
          <div class="precio-final">
            {{(localidad.precio + localidad.servicio_iva + localidad.servicio) | currency:'COP'}}
          </div>
        </div>
      </div>
    </div>

    <!-- VIERNES -->
    <div class="accordion-item">
      <div class="accordion-header" (click)="toggleAccordion('viernes')" 
           [class.active]="accordionState.viernes">
        <h3>{{getNombreEtapa(1)}}</h3>
        <div class="precio-desde">
          <span>Desde:</span>
          <span class="precio-min">{{getPrecioMinimo(1) | currency:'COP'}}</span>
        </div>
        <span class="accordion-icon" [class.rotated]="accordionState.viernes">▼</span>
      </div>
      <div class="accordion-content" [class.show]="accordionState.viernes">
        <div routerLink="compra" class="localidad-item" *ngFor="let localidad of getLocalidadesPorEtapa(1); let i = index"
             [style.animation-delay]="(i * 50) + 'ms'">
          <div  class="localidad-info">
            <span class="localidad-nombre">{{localidad.nombre}}</span>
            <span class="ticket-badge">{{localidad.cantidadPersonasPorTicket}} Ticket<span *ngIf="localidad.cantidadPersonasPorTicket>1">s</span></span>
          </div>
          <div class="precio-final">
            {{(localidad.precio + localidad.servicio_iva + localidad.servicio) | currency:'COP'}}
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

    <table *ngIf="evento?.id !=1986" class=" centrar ffc tablatck">

        <td class="theader fondoTabla ">
          <div class="centrar">
            Etapa
          </div>
        </td>
        <td class="theader fondoTabla">
          <div class="centrar">
            Localidad
          </div>
        </td>

        <td class="theader fondoTabla">
          <div class="centrar">
            <p>Precio</p>
          </div>
        </td>

        <td class="theader fondoTabla">
          <div class="centrar fs1">
            <p>Precio incluido servicio</p>
          </div>
        </td>


      <tr class="" *ngFor="let localidad of localidades">
        <td class="tbody">
          <div>
            <h3 class="localidadNombre"><strong> {{localidad.etapa.nombre}} </strong></h3>
          </div>
        </td>
        <td class="tbody">
          <div >
            <h3 class="localidadNombre"><strong> {{localidad.nombre}} </strong>
              <br>
            <small class="naranja">{{localidad.descripcion}}</small>

            </h3>
          </div>
        </td>


        <td class="tbody">
          <div class="centrar">
            <p class="localidadPrecio" *ngIf="localidad.estado == 1" >
              <strong> SOLDOUT </strong>
            </p>
            <p class="localidadPrecio" *ngIf="localidad.estado !== 1" >

              <strong> {{calcularPrecioBaseTicket(localidad)| currency:'COP'}}</strong>

            </p>

                <small class="azul bold-lato font-small">
                  Por {{localidad.cantidadPersonasPorTicket}} Ticket<span *ngIf="localidad.cantidadPersonasPorTicket>1">s</span>
                </small>
          </div>
        </td>

        <td class="tbody">
          <div class="centrar">
            <p class="localidadPrecio" *ngIf="localidad.estado == 1" >
              <strong> SOLDOUT </strong>
            </p>
            <p class="localidadPrecio" *ngIf="localidad.estado !== 1" >
              <strong> {{calcularTotalPorTicket(localidad)| currency:'COP'}}</strong>
                </p>

                <small class="azul bold-lato font-small">
                  Por {{localidad.cantidadPersonasPorTicket}} Ticket<span *ngIf="localidad.cantidadPersonasPorTicket>1">s</span>
                </small>
          </div>
        </td>

      </tr>
    </table>
</section>






<section class="container-fluid centrarTexto mt-5" *ngIf="evento?.soldOut">
  <div class="row">
    <div class="col-12">
      <img  class="soldoutImg" src="../../../assets/images/img/SOLDOUT.png" class="w50" alt="">
    </div>
  </div>
</section>

<section class="container-fluid" *ngIf="localidades.length > 0 && localidades.length >= 0 && !evento.soldOut">
  <div class="row">
    <div class="col-12 centrarTexto mt-3">
      <button  *ngIf="evento?.id != 1957" class=" btnLog botonCompra rounded pt-2 pb-2  action_button bg-boton montserrat"
        routerLink="compra">COMPRAR
      </button>
      <button *ngIf="evento?.id == 1957" class=" btnLog botonCompra rounded pt-2 pb-2  action_button bg-boton montserrat"
      routerLink="compra">DONACIÓN
      </button>
    </div>
  </div>

  <div class="centrar">
    <p class="advertencia">*La empresa All Tickets no es responsable de la producción, realización o calidad del evento, consulte aquí los <a class="" href="https://codigos.allticketscol.com/TerminosYCondiciones.html"  target="_blank">Términos y Condiciones</a>*</p>

      <p class="advertencia">*All Tickets es el único operador de boletería autorizado*</p>
  </div>

</section>
